import { XCircle } from 'lucide-react'
import { apiFetch } from '../api/client'

export function BillingCanceledPage() {
  async function tryAgain() {
    try {
      const body = await apiFetch<{ checkout_url: string }>(
        '/api/billing/start-subscription',
        { method: 'POST' },
      )
      if (body.checkout_url) {
        window.location.assign(body.checkout_url)
      }
    } catch (err) {
      console.error('start-subscription failed', err)
    }
  }

  return (
    <div className="min-h-screen bg-background text-text-primary">
      <main className="mx-auto max-w-md px-6 py-16">
        <div className="space-y-4 rounded-xl border border-border bg-surface p-8 text-center shadow-lg">
          <XCircle className="mx-auto h-10 w-10 text-text-secondary" />
          <h1 className="text-lg font-semibold">Subscription not started</h1>
          <p className="text-sm text-text-secondary">
            You closed the Checkout before completing the subscription. No card
            was charged.
          </p>
          <div className="flex flex-col gap-2 sm:flex-row sm:justify-center">
            <button
              onClick={tryAgain}
              className="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-background"
            >
              Try again
            </button>
            <button
              onClick={() => window.location.assign('/')}
              className="rounded-lg border border-border px-4 py-2 text-sm font-medium"
            >
              Back to dashboard
            </button>
          </div>
        </div>
      </main>
    </div>
  )
}
